var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6775,
    cy: 9.5,
    rx: 10.6775,
    ry: 9.5,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2129 9.50007H21.3544C21.3547 8.66226 21.2309 7.82908 20.9862 7.02124L10.2129 7.02195V9.50007Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2129 4.54295H19.7873C19.1342 3.59595 18.3004 2.75706 17.3232 2.06519H10.2129V4.54295Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6771 19.0001C13.0918 19.0033 15.4358 18.275 17.3234 16.9348H4.03076C5.91829 18.275 8.2623 19.0033 10.6771 19.0001Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56686 14.4569H19.7875C20.3185 13.6861 20.7223 12.8515 20.9867 11.9788H0.367676C0.632016 12.8515 1.03587 13.6861 1.56686 14.4569Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94611 1.48332H5.9194L5.01594 2.06815L5.36174 3.018L4.45823 2.43353L3.55478 3.018L3.85376 2.20053C3.05547 2.79214 2.358 3.48365 1.78315 4.25367H2.09527L1.52032 4.62655C1.43048 4.75965 1.34426 4.89488 1.26159 5.03226L1.53671 5.78551L1.02337 5.45366C0.888669 5.69238 0.769859 5.93715 0.666941 6.188L0.970031 7.01547H2.0887L1.18519 7.59994L1.531 8.55015L0.627488 7.96533L0.0854229 8.31608C0.0295271 8.70894 0.00100262 9.1043 0 9.50001H10.6775V1.18051e-05C8.64697 -0.00284276 6.65803 0.51205 4.94611 1.48332ZM5.35654 8.5501L4.45308 7.96527L3.54962 8.5501L3.89537 7.59988L2.99192 7.01541H4.10647L4.45228 6.0652L4.79803 7.01541H5.91916L5.0157 7.59988L5.35654 8.5501ZM5.01022 4.83646L5.35602 5.78631L4.45256 5.20184L3.54906 5.78631L3.89486 4.83646L2.9914 4.25163H4.10676L4.45256 3.30177L4.79832 4.25163H5.91944L5.01022 4.83646ZM9.18965 8.5501L8.28614 7.96527L7.38269 8.5501L7.72844 7.59988L6.81676 7.01541H7.93874L8.28449 6.0652L8.63029 7.01541H9.74896L8.8455 7.59988L9.18965 8.5501ZM8.84387 4.83646L9.18968 5.78631L8.28617 5.20184L7.38271 5.78631L7.72846 4.83646L6.82501 4.25163H7.93876L8.28451 3.30177L8.63032 4.25163H9.74899L8.84387 4.83646ZM8.84387 2.06888L9.18968 3.01874L8.28617 2.43426L7.38271 3.01874L7.72846 2.06888L6.82501 1.48405H7.93876L8.28451 0.534191L8.63032 1.48405H9.74899L8.84387 2.06888Z",
    fill: "#0052B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.e64c5bd9ee19f29bcb2cee6c81aff9e3.svg";
export { ForwardRef as ReactComponent };